import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'CustomerLevel',
    column_type: 'id',
  },
  created_at: {
    model_name: 'CustomerLevel',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'CustomerLevel',
    column_type: 'datetime',
  },
  name: {
    model_name: 'CustomerLevel',
    column_type: 'string',
  },
  remind_days: {
    model_name: 'CustomerLevel',
    column_type: 'integer',
  },
  description: {
    model_name: 'CustomerLevel',
    column_type: 'string',
  },
  yearly_min_order_amount: {
    model_name: 'CustomerLevel',
    column_type: 'decimal',
  },
  yearly_max_order_amount: {
    model_name: 'CustomerLevel',
    column_type: 'decimal',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
